import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.scss';
import PropTypes from 'prop-types';

function ApartmentsGallery({ photos }) {
  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);
  const [slider1, setSlider1] = useState(null);
  const [slider2, setSlider2] = useState(null);

  useEffect(() => {
    setNav1(slider1);
    setNav2(slider2);
  }, [slider2, slider1]);

  const settingsMain = {
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    infinite: false,
    asNavFor: '.slider-nav'
  };

  const settingsThumbs = {
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.slider-for',
    dots: false,
    arrows: false,
    swipeToSlide: true,
    focusOnSelect: true,
    infinite: false,
    centerPadding: '10px'
  };

  return (
    <div className="App">
      <div className="apartments-modal__gallery">
        <Slider
          {...settingsMain}
          asNavFor={nav2}
          ref={slider => setSlider1(slider)}
        >
          {photos}
        </Slider>
        {photos?.length > 1 && (
          <div className="apartments-modal__gallery-thumbnails">
            <Slider
              {...settingsThumbs}
              asNavFor={nav1}
              ref={slider => setSlider2(slider)}
            >
              {photos}
            </Slider>
          </div>
        )}
      </div>
    </div>
  );
}

ApartmentsGallery.propTypes = {
  photos: PropTypes.array
};

export default ApartmentsGallery;
